import { FetchContext } from '../fetch-context';
import { AddressTypeCode, WinnerAddress } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateWinnerAddress: (
  fetchContext: FetchContext,
  questionnaireId: number,
  addressTypeCode: AddressTypeCode,
  winnerAddress: WinnerAddress,
  accessToken?: string,
) => Promise<void> = (fetchContext, questionnaireId, addressTypeCode, winnerAddress, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/address/${addressTypeCode}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(winnerAddress),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update winner address'));
};
